import React, { useState } from "react";
import { Box, FormControl, Select, MenuItem, Button, Typography, Chip } from "@mui/material";

const PriorityEditor = React.memo(({ member, saving, onUpdatePriority }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(member.priority || 5);

  const handleSave = async () => {
    await onUpdatePriority(member.calendar_id, editValue);
    setIsEditing(false);
  };

  const getPriorityLabel = (value) => {
    const priorityOptions = [
      { label: "High", value: 1 },
      { label: "Medium", value: 5 },
      { label: "Low", value: 10 },
    ];
    const option = priorityOptions.find(opt => opt.value === value);
    return option ? option.label : "Medium";
  };

  const getPriorityColor = (value) => {
    switch(value) {
      case 1: return "#d32f2f";
      case 5: return "#ed6c02";
      case 10: return "#2e7d32";
      default: return "#666666";
    }
  };

  const priorityOptions = [
    { label: "High", value: 1 },
    { label: "Medium", value: 5 },
    { label: "Low", value: 10 },
  ];

  if (isEditing) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <Select
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            displayEmpty
            sx={{
              backgroundColor: '#fff',
              borderRadius: '6px',
            }}
          >
            {priorityOptions.map((option) => (
              <MenuItem 
                key={option.value} 
                value={option.value}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <Typography variant="body2">
                  {option.label}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          size="small"
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          sx={{ 
            minWidth: 'auto', 
            padding: '4px 8px',
            backgroundColor: '#219297',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#197f85',
            }
          }}
        >
          Save
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => setIsEditing(false)}
          sx={{ minWidth: 'auto', padding: '4px 8px',color:"#000000" }}
        >
          Cancel
        </Button>
      </Box>
    );
  }
  
  return (
    <Chip 
      label={`${getPriorityLabel(member.priority)}`}
      size="small"
      sx={{ 
        backgroundColor: `${getPriorityColor(member.priority)}15`,
        color: getPriorityColor(member.priority),
        fontSize: '0.7rem',
        fontWeight: 500,
        border: `1px solid ${getPriorityColor(member.priority)}30`,
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    />
  );
});

export default PriorityEditor;